export const Auction = [
  {
    name: '간편검색',
    url: '/search?type=e',
    icon: 'search',
  },
  {
    name: '종합검색',
    url: '/search?type=c',
    icon: 'auction',
  },
  {
    name: '예정물건',
    url: '/scheduledAuction',
    icon: 'auction_schedule',
  },
  {
    name: '경매일정',
    url: '/auctionSchedule',
    icon: 'calendar',
  },
  {
    name: '경매신건',
    url: '/NewAuction',
    icon: 'auction_new',
  },
];

export const Map = [
  {
    name: '지도검색',
    url: '/map',
    icon: 'map',
  },
];

export const BadDebt = [
  {
    name: 'NPL검색',
    url: '/search/npl',
    icon: 'diamond',
  },
  {
    name: 'NPL 거래소',
    url: 'https://nplatform.ai/',
    icon: 'npl',
  },
];

export const Insight = [
  {
    name: '월간/주간 통계',
    url: '/period-stats',
    icon: 'graph',
  },
  {
    name: '나만의 통계',
    url: '/premium-stats',
    icon: 'graph-bar',
  },
  {
    name: 'NPL 통계',
    url: '/npl-stats',
    icon: 'npl',
  },
];

export const MyAiAnalysis = [
  {
    name: '나만의 알고리즘 만들기',
    url: '/myAlgorithm',
    icon: 'algorithm',
  },
  {
    name: '나만의 알고리즘 보관함',
    url: '/myAlgorithmList',
    icon: 'archive',
  },
  {
    name: 'AI 기반 실시간 경매 추천',
    url: '/AiRecommendation',
    icon: 'auction_ai',
  },

  {
    name: '퀀트 분석 기반 테마 추천',
    url: '/quant',
    icon: 'quant',
  },
];

export const StudyRoom = [
  {
    name: '경매절차',
    url: '/studyroom?type=p',
    icon: 'document_confirm',
  },
  {
    name: '경매용어',
    url: '/studyroom?type=t',
    icon: 'lightbulb',
  },
  {
    name: '경매서식',
    url: '/studyroom?type=f',
    icon: 'realty',
  },
];

export const Mypage = [
  {
    name: '관심물건',
    url: '/mypage',
    icon: 'like',
  },
  {
    name: '최근 본 물건',
    url: '/mypage',
    icon: 'time',
  },
  {
    name: '퀀트 분석 리포트',
    url: '/mypage',
    icon: 'document',
  },
  {
    name: '쿠폰함',
    url: '/mypage',
    icon: 'coupon',
  },
  {
    name: '결제 안내',
    url: '/payment/plan',
    icon: 'coin',
  },
  {
    name: '결제내역',
    url: '/mypage',
    icon: 'receipt',
  },
  {
    name: '1:1 문의하기',
    url: '/mypage',
    icon: 'inquire',
  },
  {
    name: '내 정보 수정',
    url: '/mypage',
    icon: 'pen',
  },
];

export const CS = [
  {
    name: '공지사항',
    url: '/board',
    icon: 'announcement',
  },
  {
    name: '서비스 이용안내',
    url: '/guide',
    icon: 'info',
  },
  {
    name: 'FAQ',
    url: 'https://transfarmer.notion.site/zipgo-auction-faq',
    icon: 'help',
  },
  {
    name: '1:1 문의',
    url: '',
    icon: 'inquire',
  },
];

export const Service1 = [
  {
    sectionTitle: '경공매검색',
    subItems: Auction,
  },
  {
    sectionTitle: '지도',
    subItems: Map,
  },
  {
    sectionTitle: '부실채권검색',
    subItems: BadDebt,
  },
  {
    sectionTitle: '땅집고 인사이트',
    subItems: Insight,
  },
  {
    sectionTitle: '나만의 AI 경매분석',
    subItems: MyAiAnalysis,
  },
  {
    sectionTitle: '스터디룸',
    subItems: StudyRoom,
  },
];

export const Service2 = [
  {
    sectionTitle: '마이페이지',
    subItems: Mypage,
  },
];

export const Service3 = [
  {
    sectionTitle: '고객센터',
    subItems: CS,
  },
];
